import { Resvg } from '@cf-wasm/resvg/legacy/workerd';
import { satori } from '@cf-wasm/satori/workerd';
import { defaultFont } from './core';
import { modules } from './core/modules';
import notoSansFontBuffer from './lib/noto-sans-v27-latin-regular.ttf.bin.inline';

// Set modules
modules.set({ Resvg }, { satori });

// Set default font
defaultFont.set(notoSansFontBuffer);

export * from './core';
